import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaArrowLeft, FaCamera, FaHome, FaImages } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { ownsEvents } from '../utils/roles';
import './NotFound.css';

function NotFound() {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  const homePath = isAuthenticated ? '/dashboard' : '/';
  const browsePath = ownsEvents(user) ? '/photographer' : '/events';
  const browseLabel = ownsEvents(user) ? 'My Events' : 'Browse Events';

  return (
    <section className="not-found-page">
      <div className="not-found-visual" aria-hidden="true">
        <FaCamera />
        <span>404</span>
      </div>

      <div className="not-found-content">
        <p className="not-found-kicker">Page not found</p>
        <h1>This photo never developed.</h1>
        <p>
          We could not find <code>{location.pathname}</code>. The link may be outdated,
          private, or moved to a different gallery.
        </p>

        <div className="not-found-actions">
          <Link to={homePath} className="not-found-primary">
            <FaHome />
            <span>{isAuthenticated ? 'Dashboard' : 'Home'}</span>
          </Link>
          <Link to={browsePath} className="not-found-secondary">
            <FaImages />
            <span>{browseLabel}</span>
          </Link>
          <button type="button" className="not-found-ghost" onClick={() => window.history.back()}>
            <FaArrowLeft />
            <span>Go Back</span>
          </button>
        </div>
      </div>
    </section>
  );
}

export default NotFound;
